// Also need to add for home, report page,

const MENU_VIEW = 2;
const MENU_EDIT = 4;
const ORDER_VIEW = 8;
const ORDER_EDIT = 16;
const PROVIDERS_VIEW = 32;
const PROVIDERS_EDIT = 64;
const SETTINGS_ACCOUNT = 128;
const SETTINGS_WEBSITE = 256;
const SETTINGS_BUSINESS = 512;
const SETTINGS_ADVANCED = 512;
const SETTINGS_LANGUAGE = 512;
const SETTINGS_USERS = 1024;
const SETTINGS_BILLING = 2048;
const BATCH_REPORT = 4096;
const HOME_REPORT_FILTER = 8192;
const SETTINGS_ADMIN = 16384;
const SCHEDULE_READ = 32768;
const SCHEDULE_EDIT = 65536;
const SETTINGS_PRINTERS = 131072;
const SETTINGS_EVENTS = 262144;
const SETTINGS_BRAND_LOCATIONS = 524288;
const SETTINGS_ADD_LOCATION = 1048576;
const TUTORIAL_VIEW = 2097152;
const PROFIT_IQ_VIEW = 8388608;
// const HELP_VIEW = 4194304;
// const HELP_EDIT = 8388608;
// const MENU_MANAGE = 16777216;
// const ORDER_HISTORY_VIEW = 33554432;
// const ORDER_HISTORY_EDIT = 67108864;
// const SETTINGS_VIEW = 134217728;
// const SETTINGS_EDIT = 268435456;
const HELP_VIEW = 0;
const HELP_EDIT = 0;
const MENU_MANAGE = SETTINGS_BUSINESS;
const ORDER_HISTORY_VIEW = ORDER_VIEW;
const ORDER_HISTORY_EDIT = ORDER_VIEW;
const SETTINGS_VIEW = SETTINGS_BUSINESS;
const SETTINGS_EDIT = SETTINGS_BUSINESS;
const CHARGE_BACK = SETTINGS_ADMIN;

const UNCONFIRMED = 1;
const PENDING = 2;
const ACTIVE = 3;

const SUPER = 4194302;
const ADMIN = 4177918;
const VIRTUAL_ADMIN = 4177918;
const FRANCHISE_ADMIN = 4177918;
const CORPORATE_ADMIN = 4177918;
const MANAGER = 505854;
const LOCATION_ADMIN = 1030142;
const USER = 32922;
const MARKETPLACE_OWNER = 2011022;
const POWER_USER = 2091002;
/** Virtual Order Manager role (name: virtual_order_manager, label: Virtual Order Manager) */
const VIRTUAL_ORDER_MANAGER = 4194304;

const APP_BUNDLE = 2;
const WEB_BUNDLE = 4;
const PREMIUM = 14;
const EXTERNAL_BUNDLE = 30;

const DISPUTE_ADMIN = 32922;

export {
  MENU_VIEW,
  MENU_EDIT,
  ORDER_VIEW,
  ORDER_EDIT,
  BATCH_REPORT,
  APP_BUNDLE,
  UNCONFIRMED,
  WEB_BUNDLE,
  PREMIUM,
  PROVIDERS_VIEW,
  PROVIDERS_EDIT,
  SETTINGS_ACCOUNT,
  SETTINGS_USERS,
  SETTINGS_BILLING,
  SETTINGS_PRINTERS,
  SETTINGS_EVENTS,
  SETTINGS_BRAND_LOCATIONS,
  SETTINGS_ADD_LOCATION,
  SETTINGS_WEBSITE,
  SETTINGS_BUSINESS,
  HOME_REPORT_FILTER,
  SETTINGS_ADMIN,
  SCHEDULE_READ,
  SCHEDULE_EDIT,
  TUTORIAL_VIEW,
  PROFIT_IQ_VIEW,
  HELP_VIEW,
  HELP_EDIT,
  MENU_MANAGE,
  ORDER_HISTORY_VIEW,
  ORDER_HISTORY_EDIT,
  SETTINGS_VIEW,
  SETTINGS_EDIT,
  PENDING,
  ACTIVE,
  ADMIN,
  VIRTUAL_ADMIN,
  FRANCHISE_ADMIN,
  CORPORATE_ADMIN,
  SUPER,
  USER,
  MANAGER,
  LOCATION_ADMIN,
  MARKETPLACE_OWNER,
  POWER_USER,
  SETTINGS_ADVANCED,
  SETTINGS_LANGUAGE,
  DISPUTE_ADMIN,
  CHARGE_BACK,
  EXTERNAL_BUNDLE,
  VIRTUAL_ORDER_MANAGER,
};
